import BtnRoot from './btnRoot'


let btnRoot = null
const handlerListener = (obj) => {

    Object.keys(obj).forEach((key)=>{
      switch (key) {
        case 'btnCode':
         btnRoot.dispatchEvent(obj[key])
          break;
      
        default:
          break;
      }
    })

   

}
/**
 * 创建对象控制器
 * @param {*} app 
 * @param {*} option 
 */
const optionControl = (app,option) => {
        // 创建按钮对象
  btnRoot = new BtnRoot(app,option)

  btnRoot.registerDirecitve(app)

}
const postMessages = () => {
  
   window.openModal = () => {
    parent.postMessage({
      type: 'open'
    },'*')
   }
   window.closeModal = () => {
    parent.postMessage({
      type: 'close'
    },'*')
   }
}
/**
 * app.use
 * @param {*} app
 * @returns
 */
const install = (app,option) => {
  // 判断是否安装
  if (install.installed) return

  optionControl(app,option)

  /**
   * 监听iframe的信息
   */
  const onMessage = obj => {
    
    obj.data.type === 'global' && handlerListener(obj.data.value)
  }
  /**
   * 监听父窗口的发送信息
   */
  const addMessageListener = () => {
    // 页面加载完成监听父窗口的postMessage
    if (typeof window.addEventListener !== 'undefined') {
      window.addEventListener('message', onMessage, false)
    } else if (typeof window.attachEvent !== 'undefined') {
      window.attachEvent('onmessage', onMessage)
    }
  }
  // 添加信息监听
  addMessageListener()
  // 发送消息到父窗口的管理
  postMessages()
}

export default {
  install
}
